const a=(t,s)=>{const r=t.find(e=>e.code.toLowerCase()===s.toLowerCase().split("-")[1])||t[0];return [r,...t.filter(e=>e.code!==r.code).sort((e,c)=>{const o=e.name,n=c.name;return o<n?-1:o>n?1:0})]};

export { a as sortActiveCountries };
//# sourceMappingURL=contact-channels153.js.map
